import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { SeverityIcon } from "@/components/SeverityIcon";
import { formatDistanceToNow, format } from "date-fns";

const Activity = () => {
  const [logs, setLogs] = useState([]);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/activity?limit=200");
      setLogs(data);
    } catch (e) {
      console.error("Activity.load failed", e);
    }
  }, []);

  useEffect(() => {
    const initial = setTimeout(load, 0);
    const id = setInterval(load, 5000);
    return () => { clearTimeout(initial); clearInterval(id); };
  }, [load]);

  return (
    <div className="space-y-6" data-testid="activity-page">
      <div>
        <div className="label-mono">// AUDIT TRAIL</div>
        <h1 className="font-display text-3xl sm:text-4xl font-black tracking-tight mt-1">Activity Log</h1>
        <p className="text-sm text-zinc-500 mt-1">Every dispatch event, response, and escalation — in order.</p>
      </div>

      <div className="tac-card divide-y divide-white/5">
        {logs.length === 0 ? (
          <div className="p-12 text-center label-mono">// NO EVENTS</div>
        ) : (
          logs.map((log) => (
            <div key={log.log_id} className="px-5 py-4 flex items-start gap-4 hover:bg-white/[0.03]" data-testid={`log-${log.log_id}`}>
              <div className="mt-1"><SeverityIcon severity={log.severity} /></div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="label-mono">{log.type.replace(/_/g, " ")}</span>
                  {log.guard_name && <span className="text-xs text-zinc-500">· {log.guard_name}</span>}
                </div>
                <p className="text-sm text-zinc-200 mt-1 break-words">{log.message}</p>
              </div>
              <div className="font-mono text-[0.65rem] text-zinc-500 text-right shrink-0">
                <div>{formatDistanceToNow(new Date(log.timestamp), { addSuffix: true })}</div>
                <div className="opacity-60 mt-1">{format(new Date(log.timestamp), "MMM d HH:mm:ss")}</div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default Activity;
